import PropTypes from 'prop-types';
import React, { Component } from 'react';
import submitForm from '../../services/formService';
import { send } from '../../utils/Analytics';
import { FormContainer, FormGroup } from './styles';
import { getLeadFormValidation, isFieldValid, isFormValid } from '../../utils/validation';
import Button from 'pubweb-react-components/dist/components/Buttons/Button';
import Spinner from './styles/Spinner';
import Checkbox from './Checkbox';
import Heading from 'pubweb-react-components/dist/components/Typography/Heading';
import BodyCopy from 'pubweb-react-components/dist/components/Typography/BodyCopy';
import FormField from './FormField';
import FormError from './styles/FormError';

import colors from 'pubweb-react-components/dist/styles/colors';

export class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            values: {
                firstName: '',
                lastName: '',
                email: '',
                zip: '',
                phone: '',
                canEmail: true
            },
            touched: {},
            submitting: false,
            isLeadForm: false,
            apiError: null
        };

        this.handleDisabledClick = this.handleDisabledClick.bind(this);
        this.updateFormValue = this.updateFormValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFormType = this.handleFormType.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    updateFormValue(field) {
        return value => {
            if (!field || value === undefined) {
                console.error('Error updating form values', field, value);
            }
            let currentValues = this.state.values;
            currentValues[field] = value;
            let currentTouchedState = this.state.touched;
            currentTouchedState[field] = false;
            this.setState({
                values: currentValues,
                touched: currentTouchedState
            });
        };
    }

    handleSubmit(ev) {
        ev.preventDefault();
        this.setState({ submitting: true });
        const formValues = this.state.isLeadForm || this.props.isQuiz
            ? { ...this.state.values }
            : { email: this.state.values.email };
        const formTypes = {
            ...this.props.formTypes,
            originWebFormType: this.state.isLeadForm || this.props.isQuiz ? 'lead-form' : 'marketing-form',
        };

        submitForm({ ...formValues, ...formTypes })
            .then(results => {
                this.setState({ submitting: false, apiError: null });

                if (typeof window !== undefined && this.props.options && this.props.options.redirect) {
                    this.props.options.redirect(this.state);
                }
            })
            .catch(error => {
                this.setState({ 
                    submitting: false,
                    apiError: 'An Error Occurred Submitting Your Request. Please Try Again.'
                 });
            });
        return true;
    }

    handleBlur(ev, field) {
        const validation = getLeadFormValidation(this.state.values);
        if(!isFieldValid(validation[field])){
            let currentState = this.state.touched;
            currentState[field] = true;
            this.setState({
                touched: currentState
            });
        }
    }

    handleDisabledClick(ev){
        this.setState({ touched: this.flagAllFields(this.state.isLeadForm || this.props.isQuiz) });
    }

    flagAllFields(isLeadForm){
        let touched = {};
        if(isLeadForm){
            touched.email = true;
            touched.zip = true;
            touched.firstName = true;
            touched.lastName = true;
            touched.phone = true;
        } else{
            touched.email = true;
        }
        return touched;
    }
    
    handleFormType(ev) {
        let isLeadForm = ev.target.checked;
        this.setState({
            isLeadForm: isLeadForm
        });
        if (isLeadForm) {
            if (this.props.formTypes.originWebFormCategory === 'affordable') {
                send('HIM2018', 'Check Box', 'Affordability - Contact Check Box');
            } else if (this.props.formTypes.originWebFormCategory === 'quality'){
                send('HIM2018', 'Check Box', 'Quality - Contact Check Box');
            } else if (this.props.formTypes.originWebFormCategory === 'style'){
                if (this.props.isQuiz) {
                    send('HIM2018', 'Check Box', 'Quiz - Contact Check Box');
                } else {
                    send('HIM2018', 'Check Box', 'Style - Contact Check Box');
                }
            } 
        }
        return true;
    }

    render() {
        const isSubmitting = this.state.submitting;
        const isLeadForm = this.state.isLeadForm || this.props.isQuiz;
        const { firstName, lastName, email, zip, phone } = this.state.values;
        const touched = this.state.touched;
        const validation = getLeadFormValidation(this.state.values);

        const valid = !isLeadForm ? isFieldValid(validation.email) : isFormValid(validation);
        const apiError = this.state.apiError;

        const formButtonText = this.props.isQuiz ? "See my results" : "Get My Free Guide";

        return (
            <FormContainer className="form-container" expanded={isLeadForm}>
                <Heading 
                        headingTag="h4"
                        headingSize='medium'>
                        {this.props.isQuiz ? "Enter your information to view your custom results." : this.props.options.formHeading}
                    </Heading>
                    {this.props.isQuiz ? null : 
                        <BodyCopy className="form-body-copy" paragraphType='larger-intro'>Sign up to get our FREE Home Buyer's Guide and receive more information from Clayton to help you get started!</BodyCopy>}
                <div className='marketing-form'>
                    <FormField name={'Email'}
                        value={email}
                        type={'email'}
                        onChange={this.updateFormValue('email')}
                        onBlur={ev => this.handleBlur(ev, 'email')}
                        validation={validation.email}
                        required={true}
                        requiredError={'Email address is required.'}
                        touched={touched.email}
                        validationError={'Please enter a valid email address.'}
                        width={"100%"} />
                    {this.props.isQuiz ? null :
                    <Checkbox id={'leadFormCheckbox'}
                        checked={isLeadForm}
                        text={'I also want to be contacted by a home consultant about touring homes.'}
                        onChange={this.handleFormType} />}
                </div>
                {isLeadForm && (
                    <div className='lead-form'>
                        <FormGroup className="name-group" inline={true}>
                            <FormField name={'First Name'}
                                value={firstName}
                                onChange={this.updateFormValue('firstName')}
                                onBlur={ev => this.handleBlur(ev, 'firstName')}
                                validation={validation.lastName}
                                required={isLeadForm}
                                requiredError={'First name is required.'}
                                touched={touched.firstName} />
                            <FormField name={'Last Name'}
                                value={lastName}
                                onChange={this.updateFormValue('lastName')}
                                onBlur={ev => this.handleBlur(ev, 'lastName')}
                                required={isLeadForm}
                                validation={validation.lastName}
                                requiredError={'Last name is required.'}
                                touched={touched.lastName} />
                        </FormGroup>
                        <FormGroup className="zip-group" inline={true}>
                            <FormField name={'Zip Code'}
                                value={zip}
                                type={'tel'}
                                onChange={this.updateFormValue('zip')}
                                onBlur={ev => this.handleBlur(ev, 'zip')}
                                required={isLeadForm}
                                requiredError={'Zip code is required.'}
                                validation={validation.zip}
                                validationError={'Please enter a valid zip code.'}
                                touched={touched.zip} />
                            <FormField name={'Phone Number'}
                                value={phone}
                                type={'tel'}
                                onChange={this.updateFormValue('phone')}
                                onBlur={ev => this.handleBlur(ev, 'phone')}
                                required={isLeadForm}
                                requiredError={'Phone number is required.'}
                                validation={validation.phone}
                                validationError={'Please enter a valid phone number.'}
                                touched={touched.phone} />
                        </FormGroup>
                    </div>
                )}
                {apiError ? <FormError>{apiError}</FormError> : null}
                <div className='button-wrap' onClick={(ev) => (!valid ? this.handleDisabledClick(ev) : null)}>
                    <Button
                            size='large' 
                            buttonText={isSubmitting ? <Spinner /> : formButtonText} 
                            disabled={!valid || isSubmitting} 
                            onButtonClick={this.handleSubmit}
                            backgroundColor={colors.secondaryKiddiePool} />
                </div>
                <div id='legal' className="legal-footer">
                    By clicking submit I accept and agree to <a href='https://www.claytonhomes.com/privacy'>Clayton Homes Privacy Practices</a> and understand that my contact information will be used to contact me by telephone and to provide me with marketing communications about Clayton Homes Products and services.
                </div>
            </FormContainer>
        );
    }
}

Form.propTypes = {
    options: PropTypes.shape({
        buttonText: PropTypes.string,
        selectText: PropTypes.string,
        formHeading: PropTypes.string.isRequired
    }).isRequired,
    formTypes: PropTypes.shape({
        originWebApp: PropTypes.string.isRequired,
        originWebPageType: PropTypes.string.isRequired,
        originWebFormType: PropTypes.string,
        originWebFormCategory: PropTypes.string.isRequired,
        originCampaign: PropTypes.string
    }).isRequired
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js